__turbopack_context__.v({
  "chat_widgets_wrap": "MainSiteLayout-module-scss-module__6mn62G__chat_widgets_wrap",
  "chat_widgets_wrap__mobile_up": "MainSiteLayout-module-scss-module__6mn62G__chat_widgets_wrap__mobile_up",
  "root": "MainSiteLayout-module-scss-module__6mn62G__root",
  "root__content": "MainSiteLayout-module-scss-module__6mn62G__root__content",
  "root__gray": "MainSiteLayout-module-scss-module__6mn62G__root__gray",
  "root__purple": "MainSiteLayout-module-scss-module__6mn62G__root__purple",
});
